<template lang="pug">
  app-dialog(v-model="$_show" width="300" :header="header" :confirm-disabled="date == null" confirm-text="Далее" @confirm="handleConfirm")
    app-date-picker(v-model="date" :type="dateType" :view-format="format")
</template>

<script>
import AppDialogToggable from './AppDialogToggable'
import moment from 'moment'
moment.locale('ru')

export default {
  mixins: [AppDialogToggable],
  name: 'app-dialog-date-picker',
  props: {
    type: {
      type: String,
      default: 'day',
      validator: (value) => ['day', 'month'].indexOf(value) != -1
    }
  },

  computed: {
    header () {
      return `Выбрать ${this.type === 'month' ? 'месяц' : 'день'}`
    },

    format () {
      return this.type === 'month' ? 'MMMM YYYY' : 'DD.MM.YYYY'
    },

    dateType () {
      return this.type === 'month' ? 'month' : 'date'
    },

    period () {
      let text = moment(this.date).format(this.format)
      let start = moment(this.date).startOf(this.type).format('YYYY-MM-DD')
      let end = moment(this.date).endOf(this.type).format('YYYY-MM-DD')
      return { text, type: this.type, start, end }
    }
  },

  methods: {
    handleConfirm () {
      this.$emit('confirm', this.period)
    }
  },

  data () {
    return {
      date: null
    }
  }
}
</script>